/**
 * @flow
 * @relayHash e3d7e10a25357935a42556a063515201
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteProfessionMutationVariables = {|
  id: string
|};
export type DeleteProfessionMutationResponse = {|
  +deleteProfession: {|
    +id: string
  |}
|};
export type DeleteProfessionMutation = {|
  variables: DeleteProfessionMutationVariables,
  response: DeleteProfessionMutationResponse,
|};
*/


/*
mutation DeleteProfessionMutation(
  $id: String!
) {
  deleteProfession(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteProfession",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProfessionModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteProfessionMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteProfessionMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteProfessionMutation",
    "id": null,
    "text": "mutation DeleteProfessionMutation(\n  $id: String!\n) {\n  deleteProfession(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '14081ed119d884b68d1cb344cd78bd90';
module.exports = node;
